class MFRGallery {
  constructor(i, e) {
    this.$index = i
    this.$element = $(e)

    this.selectors = {
      group: ".grouped",
      slider: ".carousel__slides"
    }

    this.states = {
      tickerSpeed: 1,
      flick: null,
      isPaused: false
    }

    this.init()
  }

  init() {
    this.$slider = this.$element.find(this.selectors.slider)
    this.$group = this.$element.find(this.selectors.group)

    this.$slider.on('mouseenter', this.__handlePause.bind(this))
    this.$slider.on('focusin', this.__handlePause.bind(this))
    this.$slider.on('mouseleave', this.__handlePlay.bind(this))
    this.$slider.on('focusout', this.__handlePlay.bind(this))

    this.__handleGroupSlides()
    this.__handleInitializeSlider()
    this.__handleSliderTicker()
  }

  __handleGroupSlides() {
    for (let i = 0; i < this.$group.length; i += 2) {
      this.$group.slice(i, i + 2).wrapAll('<div class="carousel__item"></div>')
    }
  }

  __handleInitializeSlider() {
    this.states.flick = new Flickity(this.$slider.get(0), {
      cellAlign: 'left',
      setGallerySize: true,
      dragThreshold: 25,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: false,
      draggable: true,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25
    })

    this.states.flick.x = 0
  }

  __handleSliderTicker() {
    if (this.states.isPaused) return

    if (this.states.flick.slides) {
      this.states.flick.x = (this.states.flick.x - this.states.tickerSpeed) % this.states.flick.slideableWidth
      this.states.flick.selectedIndex = this.states.flick.dragEndRestingSelect()
      this.states.flick.updateSelectedSlide()
      this.states.flick.settle(this.states.flick.x)
    }

    window.requestAnimationFrame(this.__handleSliderTicker.bind(this))
  }

  __handlePause() {
    this.states.isPaused = true
  }

  __handlePlay() {
    if (this.states.isPaused) {
      this.states.isPaused = false
      window.requestAnimationFrame(this.__handleSliderTicker.bind(this))
    }
  }
}